"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueIdService = void 0;
var UniqueIdService = /** @class */ (function () {
    function UniqueIdService() {
        var _this = this;
        this.nextNumber = 0;
        this.idHash = {};
        this.getId = function (seed) {
            var id = seed || "gk-" + _this.nextNumber++;
            if (!_this.idHash[id]) {
                _this.idHash[id] = 0;
            }
            return id + "-" + _this.idHash[id]++;
        };
    }
    return UniqueIdService;
}());
exports.uniqueIdService = new UniqueIdService();
